import { GalleryItem } from "../types/galleryTypes";
import { Group, Image } from "../components/services/gallery/WorkCompleted";

type SortItem = {
  weight?: number | null;
};
export const weightSorter = <T extends SortItem>(items: T[]): T[] => {
  if (!items || !items.length) return [];

  return [...items].sort((a, b) => {
    const hasWeightA = typeof a.weight === "number";
    const hasWeightB = typeof b.weight === "number";

    // Case 1: both have weight → sort by ascending weight
    if (hasWeightA && hasWeightB) {
      if (a.weight! !== b.weight!) {
        return a.weight! - b.weight!;
      }
      // same weight → fall through to date
    }

    // Case 2: only A has weight → A first
    if (hasWeightA && !hasWeightB) return -1;

    // if (!hasWeightA && hasWeightB)
    return 1;
  });
};

export const groupWorkCompletedMedia = (mediaItems: GalleryItem[]) => {
  const grouped = new Map<string, Group>();

  mediaItems.forEach((item) => {
    if (item.groupId) {
      if (!grouped.has(item.groupId)) {
        grouped.set(item.groupId, {
          groupId: item.groupId,
          images: [],
          desc: item.description,
          weight: item.group?.groupWeight,
        });
      }
      const groupImages: Image[] = grouped.get(item.groupId)!.images;
      grouped.get(item.groupId)!.images = weightSorter([
        ...groupImages,
        { url: item.url, weight: item.weight },
      ]);
    } else {
      grouped.set(`standalone-${item.id}`, {
        groupId: null,
        images: [{ url: item.url, weight: item.weight }],
        desc: item.description,
        weight: item.weight,
      });
    }
  });

  return weightSorter(Array.from(grouped.values()));
};
